export const BASEURL = 'https://api.mahasukhtea.in/email'
export const URL = {
  SEND_QUERY: `${BASEURL}/query`,
  SEND_DISTRIBUTOR_DETAILS: `${BASEURL}/distributor`,
  SEND_BUSINESS_DETAILS: `${BASEURL}/business`
}
